var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{staticStyle:{"height":"100%"}},[(_vm.deveMostrarFAQ)?_c('div',[_c('ModalFAQ'),(_vm.deveMostrarPatchNotes)?_c('div',[_c('ModalPathNotes')],1):_vm._e()],1):_vm._e(),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }